/*
 * @Author: Liux
 * @Date: 2019-09-26 09:30:47
 * @LastEditor: Liux
 * @LastEditTime: 2019-09-27 07:45:27
 */
import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class AdDashboardBoxEventService {
  public onInit: EventEmitter<{
    setting: Array<{ Name: string; Value: string }>;
    instanceID: number;
    title: string;
    subTitle: string;
    type: string;
  }> = new EventEmitter();
  public onResize: EventEmitter<any> = new EventEmitter();
  public onSettingClick: EventEmitter<any> = new EventEmitter();
  public onRemove: EventEmitter<any> = new EventEmitter();
  public onButtonClick: EventEmitter<any> = new EventEmitter();
  public onButtonChange: EventEmitter<any> = new EventEmitter();
  public onSettingChange: EventEmitter<any> = new EventEmitter();
  constructor() {}
}
